import React from 'react';
import './InfoPage.css';

function About() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Sobre a Nukki</h1>

        <section className="info-section">
          <h2>Conectando pessoas através de experiências de viagem únicas</h2>
          <p>A Nukki é um mercado comunitário confiável para pessoas listarem, descobrirem e reservarem acomodações únicas ao redor do mundo. Seja um apartamento por uma noite, um castelo por uma semana ou uma vila por um mês, a Nukki conecta pessoas a experiências em qualquer faixa de preço, em mais de 190 países.</p>
        </section>

        <section className="info-section">
          <h3>Nossa Missão</h3>
          <p>Criar um mundo onde qualquer pessoa possa pertencer a qualquer lugar, proporcionando viagens saudáveis que sejam locais, autênticas, diversas, inclusivas e sustentáveis.</p>
        </section>

        <section className="info-section">
          <h3>Nossa História</h3>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-year">2024</div>
              <p>A Nukki foi fundada com a visão de revolucionar a forma como as pessoas viajam e se conectam com comunidades locais. O que começou como uma ideia simples cresceu e se tornou uma plataforma global atendendo milhões de hóspedes e anfitriões em todo o mundo.</p>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">Hoje</div>
              <p>Continuamos expandindo nosso alcance, melhorando nossa plataforma e inovando novas formas de viajantes e anfitriões se conectarem. Nossa comunidade abrange todos os continentes, reunindo pessoas através do poder das experiências compartilhadas.</p>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Em Números</h3>
          <div className="stats-grid">
            <div className="stat-box">
              <span className="stat-number">10M+</span>
              <span className="stat-label">Anúncios em Todo o Mundo</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">190+</span>
              <span className="stat-label">Países</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">500M+</span>
              <span className="stat-label">Chegadas de Hóspedes</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">5M+</span>
              <span className="stat-label">Anfitriões Ativos</span>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Nossos Valores</h3>

          <div className="feature-box">
            <h4>🌍 Defender a Missão</h4>
            <p>Acreditamos em um mundo onde qualquer pessoa pode pertencer a qualquer lugar. Cada decisão que tomamos é guiada por nossa missão de criar mudanças positivas e duradouras.</p>
          </div>

          <div className="feature-box">
            <h4>🤝 Ser um Anfitrião</h4>
            <p>Abraçamos a mentalidade de anfitrião - atencioso, cuidadoso e acolhedor. Antecipamos necessidades e criamos ambientes onde as pessoas podem prosperar.</p>
          </div>

          <div className="feature-box">
            <h4>✨ Abraçar a Aventura</h4>
            <p>Somos curiosos, criativos e abertos a novas ideias. Assumimos riscos inteligentes e aprendemos com nossos erros para impulsionar a inovação.</p>
          </div>

          <div className="feature-box">
            <h4>💪 Ser um Empreendedor Persistente</h4>
            <p>Somos engenhosos e resilientes. Trabalhamos arduamente para fazer as coisas acontecerem e não desistimos quando enfrentamos desafios.</p>
          </div>

          <div className="feature-box">
            <h4>🎯 Simplificar</h4>
            <p>Focamos no que é mais importante. Projetamos com intenção e nos comunicamos com clareza para criar experiências excepcionais.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Nosso Impacto</h3>

          <div className="help-topic">
            <h4>Empoderamento Econômico</h4>
            <p>Ajudamos pessoas comuns a ganhar uma renda significativa compartilhando suas casas. Para muitos anfitriões, a renda que ganham os ajuda a permanecer em suas casas e comunidades.</p>
          </div>

          <div className="help-topic">
            <h4>Viagem Sustentável</h4>
            <p>Ao permitir que as pessoas viajem como locais, promovemos o turismo sustentável que beneficia comunidades locais e reduz o impacto ambiental.</p>
          </div>

          <div className="help-topic">
            <h4>Conexão Comunitária</h4>
            <p>Reunimos pessoas de diferentes culturas, promovendo compreensão e construindo pontes entre comunidades ao redor do mundo.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Confiança e Segurança</h3>
          <p>A confiança é a base da nossa comunidade. Construímos sistemas abrangentes de confiança e segurança incluindo:</p>
          <ul>
            <li>Identidades de usuários verificadas</li>
            <li>Processamento seguro de pagamentos</li>
            <li>Avaliações de anfitriões e hóspedes</li>
            <li>Suporte ao cliente 24 horas por dia, 7 dias por semana</li>
            <li>Seguro de proteção para anfitriões</li>
            <li>Políticas de reembolso para hóspedes</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Inovação e Tecnologia</h3>
          <p>Estamos constantemente inovando para melhorar a experiência de viagem através da tecnologia, incluindo:</p>
          <ul>
            <li>Busca e recomendações alimentadas por IA</li>
            <li>Ferramentas de precificação inteligente para anfitriões</li>
            <li>Recursos de reserva instantânea</li>
            <li>Design de plataforma mobile-first</li>
            <li>Pré-visualizações de propriedades em realidade virtual</li>
            <li>Mensagens e tradução integradas</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Olhando para o Futuro</h3>
          <p>À medida que crescemos, permanecemos comprometidos com nossa missão de criar um mundo onde qualquer pessoa possa pertencer a qualquer lugar. Continuaremos a inovar, apoiar nossa comunidade e trabalhar por um mundo mais conectado e inclusivo através de viagens.</p>
        </section>
      </div>
    </div>
  );
}

export default About;
